import { Button } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import moment from 'moment';

import { DatePickerButton } from '../../shared';

type SubscriptionDateManagerProps = Readonly<{
  value?: string;
  onChange: (date: Date) => void;
  maxFromToday?: boolean;
}>;

export const SubscriptionDateManager = ({ value, onChange, maxFromToday = false }: SubscriptionDateManagerProps) => {
  const endDate = value ? moment.utc(value) : moment.utc();
  const maxDate = (maxFromToday ? moment.utc() : endDate.clone()).add(1, 'year').toDate();

  return (
    <DatePickerButton value={value ? endDate.toDate() : undefined} maxDate={maxDate} onDateChange={onChange}>
      <Button variant="minimal">
        <Icon name="edit" />
      </Button>
    </DatePickerButton>
  );
};
